import React, { useEffect, useState } from "react";
import Container from "@material-ui/core/Container";
import { useHistory } from "react-router-dom";
import {Card, Grid, Box, Hidden, CircularProgress, Typography, Button, useMediaQuery, useTheme} from "@material-ui/core";

import PetsListItem from "../../Components/ListItems/PetsListItem";
import Navigation from "../../Components/Navigation";
import {colorInputBorderGrayish} from "../../Constants/theme";
import { PetsProvider, PetsConsumer } from "../../Contexts";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../redux/store";
import {getPetsList} from "../../redux/pets/pets.actions";

export interface IPet {
	id: number,
	ownerId: number,
	type: "dog" | "cat" | string,
	name: string,
	vaccines: any[],
	medications: any[],
	sex: string,
	imageUrl: string,
	breed: string,
}

const Pets = () => {
    // const [petsList, setPetsList] = useState<IPet[]>([]);
    // const [petsListForProvider, setPetsListForProvider] = useState([]);
    const [isLoaderVisible, setIsLoaderVisible] = useState(false);
    let history = useHistory();
    const user = useSelector((state: RootState) => state?.user);
    const petsRedux = useSelector((state: RootState) => state?.pets.petsList);
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    useEffect(() => {
        (async () => {
            try{
                user.role === "VET" && history.push("/404");
                setIsLoaderVisible(true);
                await dispatch(getPetsList({ownerId: user.userId}));
            } catch (err) {
                console.error(err);
            }
            setIsLoaderVisible(false);
        })();
    }, []);

    // useEffect(() => {
    // 	setPetsListForProvider(petsList);
    // }, [petsList]);

    return (
        <Container maxWidth="md">
            <PetsProvider value={petsRedux}>
                <Box marginTop="115px" marginBottom="75px">
                    <Grid container>
                        {!isMobile &&
							<Grid item sm={3}>
							    <Navigation />
							</Grid>
                        }
                        <Grid item md={9} xs={12}>
                            <Card variant="outlined">
                                <Box
                                    padding="20px 40px 0 30px"
                                >
                                    <Grid container justify="space-between">
                                        <Grid item sm={8} xs={4}>
                                            <Typography variant="h3">
												My Pets
                                            </Typography>
                                        </Grid>
                                        <Grid item container sm={4} xs={8} justify="flex-end">
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color="primary"
                                                onClick={() => {
                                                    history.push(`/pets/${0}/general`);
                                                }}
                                            >
													Add New Pet
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>
                                {isLoaderVisible &&
									<Box
									    display="flex"
									    paddingY="40px"
									    padding="40px"
									    justifyContent="center"
									    flexWrap="wrap"
									    borderBottom={`1px solid ${colorInputBorderGrayish}`}
									>
									    <CircularProgress />
									</Box>
                                }
                                <PetsConsumer>
                                    {(context) => {
                                        if(context.state.value){
                                            return context.state.value.map(({id, type, name, sex, breed, imageUrl}: IPet) =>
                                                <PetsListItem
                                                    key={id}
                                                    id={id}
                                                    type={type}
                                                    name={name}
                                                    gender={sex}
                                                    breed={breed}
                                                    imageUrl={imageUrl}
                                                />
                                            );
                                        }
                                    }}
                                </PetsConsumer>
                            </Card>
                        </Grid>
                    </Grid>
                </Box>
            </PetsProvider>
        </Container>
    );
};

export default Pets;
